import './bootstrap'
import Vue from 'vue'

import DashboardPlugin from './plugins/dashboard-plugin';
//import NotificationsDemo from './components/NotificationsDemo'
//import NotificationsDropdown from './components/NotificationsDropdown'
import NotificationRegistration from './components/NotificationRegistration'
import SentList from './components/SentList'
import SubscriberList from './components/SubscriberList'
import DraftList from './components/DraftList'
import NotificationReadyList from './components/NotificationReadyList'
import TestuserList from './components/TestuserList'
import NotificationUpdate from './components/NotificationUpdate'
import NotificationDetail from './components/NotificationDetail'
import Category from './components/Category'
import Navbar from './components/Navbar'
import NavSidebar from './components/NavSidebar'
import SideBar  from './argonComponents/SidebarPlugin';
import UserList from './components/UserList'
import UserDetails from './components/UserDetails'
import UserRegistration from './components/UserRegistration'
import UserUpdate from './components/UserUpdate'

import RoleRegistration from './components/RoleRegistration'
import RoleList from './components/RoleList'
import RolePermission from './components/RolePermission'
import RoleUpdate from './components/RoleUpdate'
import PlanUpdate from './components/PlanUpdate'
import ContractInfo from './components/ContractInfo'
import ContractInfoUpdate from './components/ContractInfoUpdate'
import SiteEmbedCode from './components/SiteEmbedCode'
import SiteInfo from './components/SiteInfo'
import SiteList from './components/SiteList'
import SiteRegistration from './components/SiteRegistration'
import OptIn from './components/OptIn'
//import InitialSetup from './components/InitialSetup'





//import SmsImportExport from './components/SmsImportExport'
//import clickOutside from './directives/click-ouside.js';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

//Vue.directive('click-outside', clickOutside);

Vue.use(DashboardPlugin);
Vue.use(SideBar);

Vue.prototype.permission_list = window.PushL.permission_list;
new Vue({
  el: '#app',

  data() {
		return {
      siteId: window.PushL.site_id
    }
  },
  components: {
    //NotificationsDemo,
    //NotificationsDropdown,
    NotificationRegistration,
    SentList,
    SubscriberList,
    DraftList,
    TestuserList,
    NotificationUpdate,
    Category,
    Navbar,
    NavSidebar,
    NotificationDetail,
    NotificationReadyList,
    UserList,
    UserDetails,
    UserRegistration,
    UserUpdate,
    RoleRegistration,
    RoleList,
    RolePermission,
    RoleUpdate,
    //SmsImportExport
    PlanUpdate,
    ContractInfo,
    ContractInfoUpdate,
    SiteEmbedCode,
    SiteInfo,
    SiteList,
    SiteRegistration,
    OptIn,
    //InitialSetup
  }
})

